import { z } from "zod";
export const ServiceHealthSchema = z.object({
    ok: z.boolean(),
    latency_ms: z.number().nullable(),
    error: z.string().optional(),
});
export const ObsidianHealthSchema = ServiceHealthSchema.extend({
    vault_folder: z.string().optional(),
});
export const IntegrationsHealthResponseSchema = z.object({
    obsidian: ObsidianHealthSchema,
    checked_at: z.string().datetime(),
});
//# sourceMappingURL=integrations.js.map